
const prefix = 'note';
export const EVENTS_NOTE = {
  ADDED: `${prefix}.added`,
  EDITED: `${prefix}.edited`,
  DELETED: `${prefix}.deleted`,  
}; 
